import { render } from "./ProductSubfourslide.vue?vue&type=template&id=27d35bb4&scoped=true"
import script from "./ProductSubfourslide.vue?vue&type=script&lang=js"
export * from "./ProductSubfourslide.vue?vue&type=script&lang=js"

import "./ProductSubfourslide.vue?vue&type=style&index=0&id=27d35bb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d35bb4"]])

export default __exports__